const DEFAULT_IMAGE_WIDTH = 375

/**
 * 주어진 이미지의 크기와 품질을 기준으로, 3배 크기의 이미지 크기와 품질을 반환하는 함수
 *
 * @example
 * calculateImageSize({ height: 500 }) // { width: 1125, height: 1500, quality: 100 }
 */
export const calculateImageSize = ({
  height,
  width = DEFAULT_IMAGE_WIDTH,
  quality = 100,
}: {
  height: number
  width?: number
  quality?: number
}) => {
  return {
    width: width * 3,
    height: height * 3,
    quality,
  }
}
